import { Box, Typography } from "@mui/material"

const PlaceholderPage = ({ title = "Page" }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1">
        This is a placeholder for the {title} page. Content will be added here soon.
      </Typography>
    </Box>
  )
}

export default PlaceholderPage
